<template>
    <v-container fluid>
        <v-btn
            :loading="brokerFirms === null"
            @click="newBrokerFirm"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Broker Firms ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="brokerFirms === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="brokerFirm.id"
                    cols="12"
                    v-for="brokerFirm in brokerFirms"
                >
                    <v-card
                        class="brokerFirm-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title
                            @click="loadBrokerFirmForm(brokerFirm.id)"
                            style="cursor: pointer"
                        >
                            <h5>#{{ brokerFirm.id }}</h5>
                        </v-card-title>
                        <v-card-subtitle
                            @click="loadBrokerFirmForm(brokerFirm.id)"
                            style="cursor: pointer"
                        >
                            {{ brokerFirm.name }}
                        </v-card-subtitle>
                        <v-card-text>
                            <!--<v-chip
                                class="ma-1"
                                color="warning"
                                dark
                                small
                                v-show="brokerFirm.isLateRegistrationSuspended == true"
                            >Late Registration Suspended</v-chip>-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="brokerFirmFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeBrokerFirmForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Broker Firm Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <BrokerFirmForm
                            :brokerfirm-id="brokerFirmFormBrokerFirmId"
                            :key="brokerFirmFormKey"
                            @close="closeBrokerFirmForm"
                            @deleted="deleteBrokerFirm"
                            @saved="updateBrokerFirm"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import uuid4 from "../helpers/uuid4";
import BrokerFirmForm from "../components/forms/BrokerFirmForm";

export default {
    name: "BrokerFirms",
    props: [],

    data: function() {
        return {
            //main data
            brokerFirms: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form data
            brokerFirmFormVisible: false,
            brokerFirmFormKey: 0,
            brokerFirmFormBrokerFirmId: 0, //new BrokerFirm(),

        };
    },
    mounted: function() {
        this.getBrokerFirms();
        //
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        BrokerFirmForm
        //
    },
    methods: {
        getBrokerFirms() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("brokerfirms/get", {
                    requestId: requestId
                })
                .then(brokerFirmsResponse => {
                    if (this.requestId == brokerFirmsResponse.requestId) {
                        this.brokerFirms = brokerFirmsResponse.data.page;
                        this.totalMatches = brokerFirmsResponse.data.total;
                        this.pageSize = brokerFirmsResponse.data.pageSize;
                        this.pageNo = brokerFirmsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            brokerFirmsResponse.data.total / this.pageSize
                        );
                    }
                    if (this.pageNo > this.pagesCount)
                        this.pageNo = this.pagesCount;
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.brokerFirms !== null) this.brokerFirms = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getBrokerFirms,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newBrokerFirm() {
            this.loadBrokerFirmForm(0);
        },
        loadBrokerFirmForm(brokerFirmId) {
            this.brokerFirmFormBrokerFirmId = brokerFirmId;
            this.brokerFirmFormKey = brokerFirmId;
            this.brokerFirmFormVisible = true;
        },
        closeBrokerFirmForm() {
            this.brokerFirmFormVisible = false;
            this.brokerFirmFormKey = null;
        },
        updateBrokerFirm() {
            this.paginationDebounce(0, true);
        },
        deleteBrokerFirm() {
            this.paginationDebounce(0, true);
        },
    }
};
</script>

<style lang="stylus" scoped>
.brokerFirm-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
